'use client';
import { useEffect, useState } from 'react';
import { ActionButton } from '@/components/ui/ActionButton/ActionButton';
import s from './CookieNotice.module.scss';
import { API_URL } from '@/utils/constants';

const politicUrl = `${API_URL}/consents/get-current?document_type=%D0%94%D0%BE%D0%BA%D1%83%D0%BC%D0%B5%D0%BD%D1%82%20%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D1%8F`;

export const CookieNotice = () => {
  const [isAccepted, setIsAccepted] = useState<string | null>('true');

  // Safari с «Блокировать все cookie» бросает SecurityError при обращении к localStorage
  useEffect(() => {
    try {
      setIsAccepted(localStorage.getItem('cookies-accepted'));
    } catch {
      setIsAccepted(null);
    }
  }, []);

  if (isAccepted) return null;

  function acceptCookie() {
    try {
      localStorage.setItem('cookies-accepted', 'true');
    } catch {}
    setIsAccepted('true');
  }

  return (
    <div className={s.wrapper}>
      <div>
        <span className={s.wrapper__title}>В целях улучшения работы сайт использует cookie.</span>
        <p className={s.wrapper__subtitle}>
          Продолжая пользоваться сайтом, Вы соглашаетесь на обработку файлов cookie и других пользовательских данных в
          соответствии с <a href={politicUrl} target={'_blank'} rel={'noreferrer'}>Политикой конфиденциальности</a>. В
          случае отказа вы можете отключить сохранение
          cookie в
          настройках вашего браузера или прекратить использование сайта.
        </p>
      </div>
      <ActionButton onClick={acceptCookie}>Понятно</ActionButton>
    </div>
  );
};